import _ from 'lodash';

import { Util } from '@finley-technologies/finley-types';

import {
  LedgerTransactionGQLType,
  OrganizationGQLType,
  TAccountTypeGQLType,
} from 'types/dashboard-core-gqlTypes.generated';

import { truncateLiabilityAccountType } from 'packages/statements/ui/statementsUtils';

export interface LedgerTransactionWithAccountNameAndType
  extends LedgerTransactionGQLType {
  accountType: TAccountTypeGQLType;
  accountName: string;
  organizationName: string;
}
export type ExpensesFeesTransactions = Record<
  Util.FullDateStr,
  LedgerTransactionWithAccountNameAndType[]
>;

export const getLiabilityAccountTypeOptions = (
  accountTypes: TAccountTypeGQLType[],
) => {
  return _.map(accountTypes, (accountType) => {
    return {
      value: accountType,
      label: truncateLiabilityAccountType(accountType),
    };
  });
};

export const formatExpensesFeesTransactions = (
  countersignersConfig: Record<string, string>,
  transactions?: LedgerTransactionGQLType[],
): ExpensesFeesTransactions => {
  if (!transactions) {
    return {};
  }

  const descendingTransactions = _.reverse(_.clone(transactions));

  const descendingTransactionsWithName = _.map(
    descendingTransactions,
    (descendingTransaction) => {
      const { accountType, organizationId } = descendingTransaction;
      const accountName = truncateLiabilityAccountType(accountType);
      return {
        ...descendingTransaction,
        accountType,
        accountName: accountName || accountType,
        organizationName:
          countersignersConfig[organizationId] || 'Countersigner',
      };
    },
  );

  const transactionsByDate = _.groupBy(
    descendingTransactionsWithName,
    'postingDate',
  );

  return transactionsByDate;
};

export const getCountersignersConfig = (
  countersigners: Pick<
    OrganizationGQLType,
    'id' | 'name' | 'type' | 'slug' | 'industry'
  >[],
) => _.mapValues(_.keyBy(countersigners, 'id'), 'name');

export const getCountersignersFilterOptions = (
  countersigners: Pick<
    OrganizationGQLType,
    'id' | 'name' | 'type' | 'slug' | 'industry'
  >[],
) => {
  const countersignersConfig = getCountersignersConfig(countersigners);
  return _.map(countersignersConfig, (countersigner, key) => {
    return {
      label: countersigner,
      value: key,
    };
  });
};
